// Shared browser-geolocation capture + reverse geocode (keyless client API).
export function captureLocation() {
  return new Promise((resolve, reject) => {
    if (!("geolocation" in navigator)) {
      reject(new Error("unsupported"));
      return;
    }
    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        const { latitude, longitude } = pos.coords;
        let city = "";
        let region = "";
        try {
          const r = await fetch(
            `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`
          );
          const geo = await r.json();
          city = geo.city || geo.locality || "";
          region = geo.principalSubdivision || geo.countryName || "";
        } catch (e) {
          /* coordinates alone still work */
        }
        resolve({ city, region, lat: latitude, lng: longitude });
      },
      (err) => reject(err),
      { enableHighAccuracy: false, timeout: 15000, maximumAge: 600000 }
    );
  });
}
